import { Sparkles } from "lucide-react";
import React from "react";

import { Button } from "@/app/components/ui/button.js";

interface FitCheckUpsellProps {
	onFitCheckClick: () => void;
}

export function FitCheckUpsell({ onFitCheckClick }: FitCheckUpsellProps) {
	return (
		<div className="bg-blue-50/50 gap-4 rounded-lg p-6 border border-blue-100 mb-8 flex flex-col md:flex-row items-center">
			<img src="/images/filling-survey.png" className="w-32" alt="Planning" />
			<div className="text-center md:text-left">
				<h3 className="text-xl font-semibold tracking-normal text-gray-900 mt-1">
					Not sure if you&apos;re a good fit?
				</h3>
				<p className="text-gray-800 text-sm">
					Upload your resume and let our AI analyze how well your skills and experience match this role. Get instant
					feedback on your fit for this position.
				</p>
			</div>
			<Button onClick={onFitCheckClick}>
				<Sparkles className="h-4 mr-1" />
				Check My Fit
			</Button>
		</div>
	);
}
